import { logAndylitics, log, logAPI } from "./andyliticsApi";
import * as tools from "../helpers/Tools";


export const requestAccess = (token, firstName, middleName, lastName, dateOfBirth, address, city, state, zipCode, relationship) => {
   /*API is not ready
    *const url = "" 
    const start = new Date();
    const data = { firstName, middleName, lastName, dateOfBirth, address, city, state, zipCode, relationship };
    return fetch2(url, token, JSON.stringify(data), 'post').then(response => {
        logAPI("MBHWeb.Api.MyChart.Proxy.RequestProxyAccess", start, url);
        return response;
    }).catch(err => { logAPI("MBHWeb.Api.MyChart.Proxy.RequestProxyAccess.Failure", start, url, err); return Promise.reject(err); });*/
    return;
};